import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import {
  IPBoardDesignPickerHelper,
  PhoneNumberWithOptions,
  PhoneNumberOption
} from '../ip-board-design-picker-helper';

@Component({
  selector: 'ip-board-part-phone-number-picker',
  templateUrl: './ip-board-part-phone-number-picker.component.html',
  styleUrls: ['./ip-board-part-phone-number-picker.component.scss']
})
export class IPBoardPartPhoneNumberPickerComponent implements OnInit {
  @Input()
  phoneNumberWithOptions: PhoneNumberWithOptions;

  @Output()
  save = new EventEmitter<any>();

  OTHER_PHONE_NUMBER_OPTION_ID =
    IPBoardDesignPickerHelper.OTHER_PHONE_NUMBER_OPTION_ID;

  selectedPhoneNumberOption: PhoneNumberOption;

  ngOnInit(): void {
    this.selectedPhoneNumberOption = this.getSelectedPhoneNumberOption();
  }

  private getSelectedPhoneNumberOption(): PhoneNumberOption {
    if (
      StringHelper.isEmpty(
        this.phoneNumberWithOptions.ipBoardPartPhoneNumber.phoneNumber
      )
    ) {
      return null;
    }
    const seek = this.phoneNumberWithOptions.options.find(
      o =>
        o.label ===
        this.phoneNumberWithOptions.ipBoardPartPhoneNumber.phoneNumber
    );
    return seek == null
      ? this.phoneNumberWithOptions.options[
          this.phoneNumberWithOptions.options.length - 1
        ]
      : seek;
  }

  selectedPhoneNumberOptionChanged(): void {
    if (this.selectedPhoneNumberOption == null) {
      return;
    }
    this.phoneNumberWithOptions.ipBoardPartPhoneNumber.phoneNumber =
      this.selectedPhoneNumberOption.id ===
      IPBoardDesignPickerHelper.OTHER_PHONE_NUMBER_OPTION_ID
        ? null
        : this.selectedPhoneNumberOption.label;
    this.save.emit();
  }

  compareOptions(o1: PhoneNumberOption, o2: PhoneNumberOption): boolean {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      return o1.id === o2.id;
    } else {
      return false;
    }
  }
}
